import SplashPage from './index';

export const SplashRouter = [
  {
    path: '/',
    exact: true,
    component: SplashPage,
  },
];
